/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from '@cambridgeassessment/cambridge-ui';
import thunks from '../../../../../store/components/thunks';
import { LocalSection, Section } from '../../../../../service/components/types';
import { CardInner, StyledLabel, StyledDisclaimer } from './styles';
import { Roles } from '@cambridgeassessment/lib-ee-commons';
import { Authorized } from 'lib-browser';
import { RootState } from '../../../../../store';

interface Props {
  componentId: string;
  section: Section | LocalSection;
  disabled?: boolean;
  checked: boolean;
}

const LABEL_TEXT = 'Allow multiple files for this learner section';

export const MultipleFilesSwitch: React.FC<Props> = ({ section, componentId, disabled, checked }) => {
  const dispatch = useDispatch();
  const selectedRole = useSelector((state: RootState) => state.userData.selectedRole);

  const onHandleChange = () => {
    const updatedSection = { ...section, allowMultipleFiles: !section.allowMultipleFiles } as Section;
    dispatch(thunks.updateSection(componentId, updatedSection, 'allowMultipleFiles', updatedSection.id));
  };

  return (
    <Authorized
      selectedRole={selectedRole}
      roles={[Roles.SUBMIT_SUPER_ADMIN]}
      readOnlyRoles={[Roles.SUBMIT_COMPLIANCE, Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER, Roles.SUBMIT_ADMINISTRATOR]}
    >
      <CardInner data-qa-id='switch-item-component' readOnly={disabled}>
        <StyledLabel data-qa-id={`multiple-files-label-${section.name}`}>{LABEL_TEXT}</StyledLabel>
        <Switch
          dataQaId={`multiple-files-switch-${section.name}`}
          disabled={disabled}
          checked={checked}
          onChange={onHandleChange}
          ariaLabel={LABEL_TEXT}
        />
        <StyledDisclaimer data-qa-id={`multiple-files-disclaimer-${section.name}`}>
          Note: if multiple files are allowed for a learner section, the files will not be automatically renamed by the
          system when uploaded by centres.
        </StyledDisclaimer>
      </CardInner>
    </Authorized>
  );
};

export default MultipleFilesSwitch;
